import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { decryptStorage } from 'utils/utils';
import { API_LICENSE_ORIGIN } from "../../config/config.json";

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    if (includeAuthorization) {
        const token = decryptStorage(localStorage.getItem("tokenSecurity"));
        if (token) headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_LICENSE_ORIGIN,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microServiceLicenseOriginMutation = createApi({
    reducerPath: 'microServiceLicenseOriginApi',
    baseQuery,
    endpoints: () => ({})
});